import {inject, Injectable} from '@angular/core';
import {JwtTokens, LoginParams} from "../types/auth.types";
import {Observable, tap} from "rxjs";
import {baseUrl} from "../constants/base-url";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  private http = inject(HttpClient);
  private authService: AuthService = inject(AuthService);

  public login(loginParams: LoginParams): Observable<JwtTokens> {
    return this.http.post<JwtTokens>(`${baseUrl}/perform_login`, loginParams)
      .pipe(tap((jwtTokens: JwtTokens) => {
        this.authService.doLoginUser(loginParams.username, jwtTokens)
      }));
  }

  public refreshTokens(): Observable<JwtTokens> {
    return this.http.post<JwtTokens>(`${baseUrl}/refresh`, {});
  }

  public manualRefreshTokens(): void {
    this.http.post<JwtTokens>(`${baseUrl}/refresh`, {}).subscribe({
      next: (jwtTokens: JwtTokens) => this.authService.storeJwtTokens(jwtTokens)
    });
  }
}
